import { useEffect, useState } from "react";
import { loadScript, route } from "../../../../globals/constants";
import FastImage from "../../../../globals/elements/fastimg";
import { Link, NavLink } from "react-router-dom";

function SectionHeader1() {

    const [isActive, setIsActive] = useState(false);

    useEffect(()=>{
        loadScript("js/sticky-header.js");
    })

    const handleToggleMenu = () => {
        setIsActive(!isActive);
    }

    const handleCloseMenu = () => {
        setIsActive(false);
    }

    return (
        <header className={"site-header header-style-1 mobile-sider-drawer-menu "+(isActive? 'active' : '')}>
            <div className="top-bar top-bar-liner bg-secondry">
                <div className="container header-container">
                    <div className="row">
                        <div className="mt-topbar-right">
                            <ul className="list-unstyled  tb-info-liner">
                                <li><i className="site-text-primary" />Your Reliable Storage & Warehousing Partner!</li>
                            </ul>
                            <ul className="list-inline tb-social-liner">
                                <li>
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href="https://www.facebook.com/ezstorages/"
                                        aria-label="Facebook"
                                    >
                                        <i className="fa-brands fa-facebook-f" />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href="https://x.com/ezlogisticskw"
                                        aria-label="Twitter"
                                    >
                                        <i className="fa-brands fa-x-twitter" />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href="https://www.linkedin.com/company/ezstorages"
                                        aria-label="LinkedIn"
                                    >
                                        <i className="fa-brands fa-linkedin-in" />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href="https://www.instagram.com/ezstorages/"
                                        aria-label="Instagram"
                                    >
                                        <i className="fa-brands fa-instagram" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {/* Search Link */}
            <div className="header-middle bg-white">
                <div className="container header-container">
                    <div className="logo-header">
                        <NavLink to={route.home.HOME1} onClick={handleCloseMenu}>
                            <FastImage src="images/logo-1.png" width={216} height={37} alt="" />
                        </NavLink>
                    </div>
                    <div className="header-info">
                        <ul>
                            <li>
                                <div>
                                    <div className="icon-sm">
                                        <span className="icon-cell  site-text-primary"><i className="iconmoon-smartphone" /></span>
                                    </div>
                                    <div className="icon-content">
                                        <strong>Phone Number</strong>
                                        <span>+965 6705 0911</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <div className="icon-sm">
                                        <span className="icon-cell  site-text-primary"><i className="iconmoon-envelope" /></span>
                                    </div>
                                    <div className="icon-content">
                                        <strong>Email Address</strong>
                                        <span>sales@ezstorages.com</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="sticky-header main-bar-wraper">
                <div className="main-bar header-botton nav-bg-primary">
                    <div className="container header-container">
                        {/* NAV Toggle Button */}
                        <button id="mobile-side-drawer" data-target=".header-nav" data-toggle="collapse" type="button" className="navbar-toggler collapsed" onClick={handleToggleMenu}>
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar icon-bar-first" />
                            <span className="icon-bar icon-bar-two" />
                            <span className="icon-bar icon-bar-three" />
                        </button>
                        {/* EXTRA Nav */}
                        <div className="extra-nav">
                            {/* Get a Quote button (hidden on mobile, visible on desktop) */}
                            <div className="extra-cell d-none d-lg-block">
                                <Link
                                    to={route.pages.contact.GET_QUOTE}
                                    className="site-button"
                                    title="Get a Quote"
                                    onClick={handleCloseMenu}
                                    style={{ whiteSpace: 'nowrap' }}
                                >
                                    <i className="fa fa-calculator" style={{ marginRight: 8 }} /> Get a Quote
                                </Link>
                            </div>
                            {/* Download Profile button (hidden on mobile, visible on desktop) */}
                            <div className="extra-cell d-none d-lg-block">
                                <Link
                                    to={route.services.SERVICES}
                                    className="site-button"
                                    title="Download Profile"
                                    onClick={handleCloseMenu}
                                    style={{ whiteSpace: 'nowrap' }}
                                >
                                    <i className="fa fa-file-download" style={{ marginRight: 8 }} />  Profile
                                </Link>
                            </div>
                            {/* Login button (customer) */}
                            <div className="extra-cell">
                                <Link
                                    to={route.customer.LOGIN}
                                    className="site-button-secondry"
                                    title="Login"
                                    onClick={handleCloseMenu}
                                    style={{ whiteSpace: 'nowrap' }}
                                >
                                    <i className="fa fa-user" style={{ marginRight: 8 }} /> Login
                                </Link>
                            </div>
                        </div>
                        {/* SITE Search */}
                        <div id="search">
                            <span className="close" />
                            <form role="search" id="searchform" action="/search" method="get" className="radius-xl">
                                <div className="input-group">
                                    <input defaultValue="" name="q" type="search" placeholder="Type to search" />
                                    <span className="input-group-btn"><button type="button" className="search-btn"><i className="fa fa-search" /></button></span>
                                </div>
                            </form>
                        </div>
                        <div className="logo-show-in-mobile">
                            <NavLink to={route.home.HOME1} onClick={handleCloseMenu}>
                                <FastImage src="images/logo-1.png" width={216} height={37} alt="" />
                            </NavLink>
                        </div>
                        {/* MAIN Nav */}
                        <div className="header-nav navbar-collapse collapse d-flex justify-content-start">
                            <ul className=" nav navbar-nav">
                                <li className="active"><NavLink to={route.home.HOME1} onClick={handleCloseMenu}>HOME</NavLink></li>
                                <li><NavLink to={route.pages.ABOUT} onClick={handleCloseMenu}>ABOUT US</NavLink></li>
                                <li>
                                <NavLink to={route.services.SERVICES} onClick={handleCloseMenu}>SERVICES<i className="fa fa-chevron-down" /></NavLink>
                                    <ul className="sub-menu">
                                        <li><NavLink to={route.services.SERVICES} onClick={handleCloseMenu}>Fulfillment & Warehousing</NavLink></li>
                                        <li><NavLink to={route.services.SERVICES} onClick={handleCloseMenu}>Palletization & Shrink Wrapping</NavLink></li>
                                        <li><NavLink to={route.services.SERVICES} onClick={handleCloseMenu}>Co-Packing & Labeling</NavLink></li>
                                        <li><NavLink to={route.services.SERVICES} onClick={handleCloseMenu}>Inbound & Outbound Logistics</NavLink></li>
                                        <li><NavLink to={route.services.SERVICES} onClick={handleCloseMenu}>Inventory Management</NavLink></li>
                                        <li><NavLink to={route.services.SERVICES} onClick={handleCloseMenu}>Quality Reporting</NavLink></li>
                                    </ul>
                                </li>
                                <li><NavLink to={route.pages.FEATURE} onClick={handleCloseMenu}>FEATURES</NavLink></li>
                                <li><NavLink to={route.pages.gallery.GALLERY1} onClick={handleCloseMenu}>GALLERY</NavLink></li>
                                <li><NavLink to={route.blog.LIST} onClick={handleCloseMenu}>BLOG</NavLink></li>
                                <li><NavLink to={route.pages.contact.CONTACT1} onClick={handleCloseMenu}>CONTACT</NavLink></li>
                                {/* Mobile-only actions - small buttons on same line */}
                                <li
                                    className="d-lg-none"
                                    style={{ marginTop: 8, display: "flex", gap: 8, justifyContent: "center" }}
                                >
                                    <NavLink
                                        to={route.pages.contact.GET_QUOTE}
                                        onClick={handleCloseMenu}
                                        className="site-button"
                                        style={{
                                            flex: "0 0 auto",
                                            padding: "6px 10px",
                                            fontSize: 12,
                                            color: "#fff",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        <i className="fa fa-calculator" style={{ marginRight: 6 }} />{" "}
                                        GET A QUOTE
                                    </NavLink>
                                    <NavLink
                                        to={route.services.SERVICES}
                                        onClick={handleCloseMenu}
                                        className="site-button"
                                        style={{
                                            flex: "0 0 auto",
                                            padding: "6px 10px",
                                            fontSize: 12,
                                            color: "#fff",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        <i className="fa fa-file-download" style={{ marginRight: 6 }} />{" "}
                                        PROFILE
                                    </NavLink>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </header>
    )
}
export default SectionHeader1;